// extracted by mini-css-extract-plugin
export default {"center_box":"index_center_box_TPnrx","adBox":"index_adBox_if64a"};